"use client";

import useTranslate from "@app/_hooks/useTranslate";
import { Paragraph } from "@ui/paragraph";
import type { SOLD_OUT_ITEM, StockStatusProps } from "../Stock.types";
import { stockStatusVariants } from "../Stock.utils";
import StockIndicator from "./StockIndicator";

export default function SoldOutItem({
  status,
  config,
}: {
  status: SOLD_OUT_ITEM;
  config: StockStatusProps;
}) {
  const t = useTranslate();
  const { type, className } = config;

  const { root: rootSlot, explanation: explanationSlot } = stockStatusVariants({
    type,
  });

  if (type === "pdp") {
    return (
      <div className={className}>
        <div className={rootSlot()}>
          <StockIndicator status={status.code} />
          <span className="inline-block">{t("soldOut")}</span>
        </div>
        <Paragraph className={explanationSlot()}>
          {t("soldOutExplanation")}
        </Paragraph>
      </div>
    );
  }

  return (
    <div className={rootSlot({ className })}>
      <StockIndicator status={status.code} />
      <span className="inline-block">{t("soldOut")}</span>
    </div>
  );
}
